import type { BuildStack } from '../stores/useBuildStacksStore.js'

const marketplaceTemplates: BuildStack[] = [
  {
    id: 'react-starter',
    name: 'React App Starter',
    description: 'Boilerplate React + Tailwind',
    category: 'pre-made',
    steps: [
      { beeName: 'arcCore', command: 'scaffold', inputs: { template: 'react' }, onError: 'halt' },
      { beeName: 'arcCore', command: 'install', inputs: { manager: 'npm' }, onError: 'halt' },
      { beeName: 'arcDeploy', command: 'build', inputs: { command: 'npm run build', outputDir: 'dist' }, onError: 'halt' }
    ],
    createdAt: '',
    updatedAt: '',
    tags: ['React', 'SPA', 'Tailwind'],
    icon: '⚛️'
  },
  {
    id: 'nextjs-starter',
    name: 'Next.js App',
    description: 'Complete Next.js application with SSR and API routes',
    category: 'pre-made',
    steps: [
      { beeName: 'arcCore', command: 'scaffold', inputs: { template: 'nextjs' }, onError: 'halt' },
      { beeName: 'arcCore', command: 'install', inputs: { manager: 'npm' }, onError: 'halt' },
      { beeName: 'arcDeploy', command: 'build', inputs: { command: 'npm run build', outputDir: '.next' }, onError: 'halt' }
    ],
    createdAt: '',
    updatedAt: '',
    tags: ['React', 'Next.js', 'Full-Stack'],
    icon: '⚛️'
  },
  {
    id: 'python-api-starter',
    name: 'Python API',
    description: 'FastAPI backend service with automatic docs',
    category: 'pre-made',
    steps: [
      { beeName: 'arcCore', command: 'setup', inputs: { language: 'python' }, onError: 'halt' },
      { beeName: 'arcCore', command: 'install', inputs: { requirements: 'fastapi uvicorn' }, onError: 'halt' },
      { beeName: 'arcTest', command: 'test', inputs: { framework: 'pytest' }, onError: 'continue' }
    ],
    createdAt: '',
    updatedAt: '',
    tags: ['Python', 'API', 'Backend'],
    icon: '🐍'
  }
]

export default marketplaceTemplates
